import Filter from './filter';

export default class TagFilter extends Filter {
    constructor(datasetName = 'filterType', initialValue = []) {
        super();
        this.datasetName = datasetName;
        this.value = initialValue;
    }

    update(value) {
        this.value = Array.isArray(value) ? value : [value];
    }

    addTag(value) {
        this.value.push(value);
    }

    removeTag(value) {
        let index = this.value.indexOf(value);
        if (index > -1) this.value.splice(index, 1);
    }

    _test(filterItem) {
        // Return true either if no tag is given or one of it exists in the filter item's filter types
        return this.value.length === 0 || filterItem.dataset[this.datasetName].split(',').some((k) => this.value.indexOf(k) !== -1);
    }
}